// services/manufacturerService.js
import api from './api';

/**
 * Получение списка всех производителей с параметрами пагинации и фильтрации
 * @param {Object} params - Параметры запроса
 * @param {boolean} includeInactive - Включать ли неактивные записи
 * @returns {Promise<Array>} Массив производителей
 */
export const getManufacturers = async (params = {}, includeInactive = true) => {
  // Добавляем параметр для включения неактивных записей, если API поддерживает такой параметр
  const queryParams = { 
    ...params,
    includeInactive: includeInactive 
  };
  
  const response = await api.get('/manufacturers', { params: queryParams });
  return response.data;
};

/**
 * Получение производителя по ID
 * @param {number} id - ID производителя
 * @returns {Promise<Object>} Данные производителя
 */
export const getManufacturerById = async (id) => {
  const response = await api.get(`/manufacturers/${id}`);
  return response.data;
};

/**
 * Создание нового производителя
 * @param {Object} manufacturerData - Данные для создания производителя
 * @returns {Promise<Object>} Созданный производитель
 */
export const createManufacturer = async (manufacturerData) => {
  const response = await api.post('/manufacturers', manufacturerData);
  return response.data;
};

/**
 * Обновление существующего производителя
 * @param {number} id - ID производителя
 * @param {Object} manufacturerData - Данные для обновления
 * @returns {Promise<Object>} Обновленный производитель
 */
export const updateManufacturer = async (id, manufacturerData) => {
  const response = await api.put(`/manufacturers/${id}`, manufacturerData);
  return response.data;
};

/**
 * Деактивация производителя (мягкое удаление через DELETE запрос)
 * @param {number} id - ID производителя
 * @returns {Promise<Object>} Результат операции
 */
export const deactivateManufacturer = async (id) => {
  const response = await api.delete(`/manufacturers/${id}`);
  return response.data;
};

/**
 * Активация производителя (через обновление)
 * @param {number} id - ID производителя
 * @param {Object} manufacturerData - Полные данные производителя
 * @returns {Promise<Object>} Обновленный производитель
 */
export const activateManufacturer = async (id, manufacturerData) => {
  const dataWithActive = {
    ...manufacturerData,
    isActive: true
  };
  const response = await api.put(`/manufacturers/${id}`, dataWithActive);
  return response.data;
};